import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import ProgramSyllabus from "@/pages/ProgramSyllabus";
import Institutions from "@/pages/Institutions";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminReviews from "@/pages/AdminReviews";

const withLayout = (Page) => (
  <Layout>
    <Page />
  </Layout>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={withLayout(Home)} />
        <Route path="/about" element={withLayout(About)} />
        <Route path="/programs" element={withLayout(Programs)} />
        <Route path="/programs/:slug" element={withLayout(ProgramSyllabus)} />
        <Route path="/institutions" element={withLayout(Institutions)} />
        <Route path="/reviews" element={withLayout(Reviews)} />
        <Route path="/contact" element={withLayout(Contact)} />

        {/* Legacy alias routes redirected to official canonical URLs */}
        <Route path="/communication-skills" element={<Navigate to="/programs/communication-business-skills" replace />} />
        <Route path="/interview-skills" element={<Navigate to="/programs/interview-skills-mock-gds" replace />} />
        <Route path="/programs/interview-skills" element={<Navigate to="/programs/interview-skills-mock-gds" replace />} />
        <Route path="/programs/communication-skills" element={<Navigate to="/programs/communication-business-skills" replace />} />
        <Route path="/programs/campus-to-cubicle" element={<Navigate to="/programs/campus-recruitment-training" replace />} />
        <Route path="/programs/soft-skills" element={<Navigate to="/programs/soft-skills-development" replace />} />
        <Route path="/programs/public-speaking" element={<Navigate to="/programs/public-speaking-debate" replace />} />
        <Route path="/programs/train-the-trainer" element={<Navigate to="/programs/train-the-trainer-programme" replace />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/reviews" element={<AdminReviews />} />
      </Routes>
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
